import axios from 'axios';
import { Product } from '../types/api';

// Get API base URL from config
const getApiBaseUrl = () => {
  if (import.meta.env.MODE === 'production') {
    return import.meta.env.VITE_API_URL || 'https://ams-admin-v2-server.amajormusic.co.uk';
  }
  return 'http://localhost:3000';
};

const API_BASE_URL = getApiBaseUrl();
const AI_PRODUCT_INFO_API = `${API_BASE_URL}/products/generate-description`;

export interface GenerateDescriptionRequest {
  title: string;
  barcodes?: string[];
  supplierCodes?: string[];
  variants?: Array<{
    sku: string;
    supplierCode?: string;
    barcode?: string;
  }>;
  productType?: string;
  tags?: string[];
  deepSearch?: boolean;
}

export interface GenerateDescriptionResponse {
  description: string;
  confidence: number;
  source: string;
}

/**
 * Generate AI-powered product description
 */
export const generateProductDescription = async (
  product: Partial<Product>,
  deepSearch: boolean = false
): Promise<GenerateDescriptionResponse> => {
  const request: GenerateDescriptionRequest = {
    title: product.name || '',
    barcodes: product.variants?.map(v => v.barcode).filter(Boolean) || [],
    supplierCodes: product.variants?.map(v => v.supplierCode).filter(Boolean) || [],
    variants: product.variants?.map(variant => ({
      sku: variant.sku,
      supplierCode: variant.supplierCode,
      barcode: variant.barcode
    })) || [],
    productType: product.productType,
    tags: product.tags?.filter(tag => tag.trim() !== '') || [],
    deepSearch
  };

  const response = await axios.post(AI_PRODUCT_INFO_API, request);
  return response.data;
};